import { MembershipPackage } from '@citruscamps/citrus-client'
import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../constants/routes'
import { formatAllocatedPeriod } from '../../../utils/formatters'
import { TruncatedText } from '../../TruncatedText/TruncatedText'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { Tooltip } from '../../Tooltip/Tooltip'

interface IProps {
  pack: MembershipPackage
  isDropdown?: boolean
  isInline?: boolean
}

export const MembershipPackSelectOption = ({
  pack,
  isDropdown = false,
  isInline = false,
}: IProps): React.JSX.Element => {
  var packDetails =
    [
      (() => {
        switch (pack.billing_period) {
          case 'year':
            return 'Billed annually'
          default:
            return `Billed ${pack.billing_period || 'month'}ly`
        }
      })(),
      !!formatAllocatedPeriod(pack) ? `${formatAllocatedPeriod(pack)}` : undefined,
    ]
      .filter(Boolean)
      .join(' · ') || '\u00A0'

  if (!isDropdown && isInline) {
    return (
      <div className="d-flex small">
        <div className="col">
          <div className={`w-100 mb-0 ${pack.is_discontinued ? 'text-line-through' : ''}`}>
            <Tooltip title={packDetails}>
              {pack.name}
              <FontAwesomeIcon icon={faInfoCircle} className="ms-1" />
            </Tooltip>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={!isDropdown ? 'd-flex' : 'd-flex small'}>
      <div className="col">
        <div className="w-100 mb-0">
          {!isDropdown ? (
            <Link
              className={`text-body ${pack.is_discontinued ? 'text-line-through' : ''}`}
              to={ROUTES.MEMBER_PACK_DETAILS.replace(':id', pack.id || '')}
            >
              <TruncatedText className="mb-1">{pack.name}</TruncatedText>
            </Link>
          ) : (
            <TruncatedText className={`mb-1 ${pack.is_discontinued ? 'text-line-through' : ''}`}>
              {pack.name}
            </TruncatedText>
          )}
          <p className="text-body-secondary small mb-sm-0">{packDetails}</p>
        </div>
      </div>
    </div>
  )
}
